import React from 'react';

import JobsListSubPage from '../../../js/pages/JobsListPage/SubPage';
import ib from '../../../js/pages/JobsListPage/ibJobs';
import {makeStaticPaths, makeStaticProps} from '../../../js/pages/JobsListPage/staticRoutes';

const Page = ({slug}) => <JobsListSubPage role={ib} slug={slug} />;

export default Page;

export const getStaticProps = makeStaticProps(ib);
export const getStaticPaths = makeStaticPaths(ib);
